<template>
  <transition
    name="fade"
    mode="out-in"
    @beforeLeave="beforeLeave"
    @enter="enter"
    @afterEnter="afterEnter"
  >
    <slot>
      <router-view />
    </slot>
  </transition>
</template>

<script>
export default {
  name: 'Child',
  data () {
    return {
      prevHeight: 0
    };
  },
  methods: {
    beforeLeave (element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter (element) {
      const { height } = getComputedStyle(element);

      element.style.height = this.prevHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter (element) {
      element.style.height = null;
    }
  }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  overflow: hidden;
  transition-duration: 0.2s;
  transition-property: height, opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
